module.exports = __webpack_public_path__ + "img/deleteBtn.d56b1dbd.svg";